const getters = {
  agentWhatsappCampaigns(state) {
    return state.agentWhatsappCampaigns;
  },
};

export default getters;
